import React, { useEffect } from 'react';
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { NavHashLink as TheNavLink } from 'react-router-hash-link';

import DefinitionDialog from './HomeComponents/DefinitionDialog';
import PolicyDialog from './HomeComponents/PolicyDialog';
import ReviewDialog from './HomeComponents/ReviewDialog';
import GiveawayDialog from './HomeComponents/GiveawayDialog';
import SubscribeForm from './HomeComponents/subscribeform';
import Logo from './HomeComponents/logo';

import Gitlab from 'img/gitlab.png';
import MorningBrew from 'img/morningbrew.png';
import theHustle from 'img/thehustle.png';
import { Mobile, NotMobile } from 'utils';
import Tickers from './tickers';


const NavLink = (props) => 
    <TheNavLink style={{ textDecoration: "none" }} {...props} />

const styles = makeStyles((theme) => ({
    wrapper: {
        maxHeight: "2000px",
        width: "100%",
        overflow: "hidden"
    },
    navbar: {
        display: "flex",
        flexDirection: "row",
        height: "140px",
        justifyContent: "center",
        alignItems: "center"
    },
    link: {
        margin: "0 20px",
        color: "black",
        cursor: "pointer",
        fontFamily: "Arvo",
        "&:hover": {
            color: "black",
            textDecoration: "underline"
        }
    },
    featured_img: {
        width: "180px",
    },
    featuredRow: {
        margin: "auto",
        display: "flex",
        alignItems: "center",
        width: "900px",
        maxWidth: "100%",
        justifyContent: "space-around"
    }, 
    featured_container: {
        margin: "24px 0 0px",
        maxWidth: "100%",
        padding: "40px 0",
        backgroundColor: "aliceblue"
    },
    as_seen_on: {
        fontSize: "27px",
        fontFamily: "Arvo",
        marginTop: "10px"
    },
    subForm: {
        marginTop: "10px",
        justifyContent: "center",
    },
    subscribeInput: {
        width: "270px",
        paddingLeft: "16px"
    },
    linksContainer: {
        display: "flex",
        flexDirection: "row",
        // justifyContent: "flex-end"
        justifyContent: "space-between"
    },
    slogan: {
        position: "absolute",
        left: "10px",
        bottom: "35px",
        fontFamily: "Lato",
        fontSize: "13px"
    },    
    definitionLink: {
        // position: "absolute",
        textAlign: "right",
        marginTop: "17px",
        marginRight: "10px",
        cursor: "pointer",
        color: "darkblue",
        fontFamily: "Lato"
    },
    contentContainer: {
        position: "relative",
        userSelect: "none" 
    },
    logo: {
        userDrag: "none",
    },
    mobileSubmit: {
    },
    '@media (max-width: 800px)': {
        featured_img: {
            width: "100px"
        },
        logo: {
            width: "130px",
            height: "130px",
        },
    },
    '@media (max-width: 767px)': {
        logo: {
            // margin: "auto",
            height: "233px",
            width: "280px",
            marginLeft: "-20px !important",
            margin: "-49px 0px"
        },
        contentContainer: {
            justifyContent: "space-around"
        },
        mobileLogoWrapper: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "0",
            marginBottom: "-50px",
            flexDirection: "column",
            alignItems: "center"
        },
        tagLine: {
            margin: "-20px 0 30px",
            fontSize: "14px"
        },
        navbar: {
            height: "55px",
            alignItems: "flex-end",
            marginBottom: "20px"
        },
        featuredRow: {
            flexDirection: "column",
            marginTop: "20px"
        },
        featured_img: {
            margin: "28px 0",
            width: "180px"
        },
        as_seen_on: {
            fontSize: "27px",
            marginRight: "-5px",
            fontFamily: "Arvo"
        },
        definitionLink: {
            position: "relative",
            right: 0,
            bottom: 0,
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto"
        }       
    }
}));

const useStyles = makeStyles((theme) => ({
    subForm: {
        marginTop: "10px",
        justifyContent: "center",
    },
    toolbarGrid: {
      padding: 16,
    },
    subscribeInput: {
        width: "270px",
        paddingLeft: "16px",
        borderRadius: "26px",
        border: "1px solid #80868b",
        outline: "none"
    },
    featured_container: {
        margin: "24px 0 0px",
        maxWidth: "100%",
        padding: "40px 0",
        backgroundColor: "aliceblue"
    },    
    as_seen_on: {
        fontSize: "27px",
        marginTop: "10px",
        fontFamily: "Arvo"
    },  
    featuredRow: {
        margin: "auto",
        display: "flex",
        alignItems: "center",
        width: "900px",
        maxWidth: "100%",
        justifyContent: "space-around"
    },  
    featured_img: {
        width: "180px",
    },
    '@media (max-width: 800px)': {
        featured_img: {
            width: "100px"
        },
    },
    '@media (max-width: 767px)': {
        as_seen_on: {
            fontSize: "27px",
            marginRight: "-5px"
        },
        featuredRow: {
            flexDirection: "column",
            marginTop: "20px"
        },
        featured_img: {
            margin: "28px 0",
            width: "180px"
        }, 
        slogan: {

        }       
    }
}))

function Featured(props) {
    const classes = useStyles();

    return (
        <Grid className={classes.featured_container} direction="column" container>
            <Grid align="center" className={classes.as_seen_on}>
                Featured On:
            </Grid>
            <Grid direction="row" className={classes.featuredRow}>
                <img alt="the hustle" className={classes.featured_img} src={theHustle} />
                <img alt="morning brew" className={classes.featured_img} src={MorningBrew} />
                <img alt="gitlab" className={classes.featured_img} src={Gitlab} />
            </Grid>
            <div style={{ margin: "auto", justifyContent: "center" }}>
                <SubscribeForm />
            </div>
        </Grid>
    )
}

export default function TopMain(props) {
    const [giveawayOpen, setGiveawayOpen] = React.useState(true);
    const [policyOpen, setPolicyOpen] = React.useState(false);
    const [definitionsOpen, setDefinitionsOpen] = React.useState(false);
    const [reviewsOpen, setReviewsOpen] = React.useState(false);

    const classes = styles();

    useEffect(() => {
        if (localStorage.getItem("seen_modal")) {
            setGiveawayOpen(false);
        }
    }, [])

    const toggleDialog = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setDefinitionsOpen(!definitionsOpen);
    }

    const toggleGiveawayDialog = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setGiveawayOpen(!giveawayOpen);
    }

    const handleClose = (value) => setDefinitionsOpen(false);
    
    const togglePolicy = () => setPolicyOpen(!policyOpen);

    const toggleReview = () => setReviewsOpen(!reviewsOpen);

    const MobileFeatured = () => (
        <Grid className={classes.featured_container} direction="column" container>
            <Grid align="center" className={classes.as_seen_on}>
                Featured On:
            </Grid>
            <Grid direction="row" className={classes.featuredRow}>
                <img className={classes.featured_img} style={{ marginBottom: "23px" }} src={theHustle} />
                <img className={classes.featured_img} style={{ marginBottom: "0px" }} src={MorningBrew} />
                <img className={classes.featured_img} src={Gitlab} />
            </Grid>
            <div style={{ margin: "auto", justifyContent: "center" }}>
                <SubscribeForm />
            </div>
        </Grid>
    )   

    return (
        <Grid direction="column" className={classes.wrapper} style={{maxWidth: 1240, margin: "auto"}}>
            <Mobile>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <Logo />
                </div>
            </Mobile>
            <Grid item direction="row" justify="space-between" 
                style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
                className={classes.contentContainer}
            >
                <NotMobile>
                    <Logo />
                </NotMobile>
                <div className={classes.navbar}>
                    <a
                        href="/#table"
                        style={{ textDecoration: "none" }}
                    >
                        <Mobile>
                            <div className={classes.link}>View Company Policies</div>
                        </Mobile>
                        <NotMobile>
                            <div className={classes.link}>Remote Work Policies</div>
                        </NotMobile>
                    </a>                    
                    <NavLink
                        to="/#benefits"
                        activeClassName="selected"
                    >
                        <NotMobile>
                            <div className={classes.link} onClick={toggleGiveawayDialog}>Win Airpods Pro</div>
                        </NotMobile>
                    </NavLink>                            
                </div>
            </Grid>
            <Mobile>
                <div className={classes.link} onClick={toggleGiveawayDialog} style={{ textAlign: "center", marginBottom: "20px" }}>Win Airpods Pro</div>
            </Mobile>                
            <Grid direction="column" container>
                <Tickers toggleDialog={toggleDialog} />
                <NotMobile>
                    <div className={classes.linksContainer}>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div className={classes.definitionLink} onClick={togglePolicy}>Submit Policy</div>
                            <div className={classes.definitionLink} onClick={toggleReview} style={{ marginLeft: "20px" }}>Submit Review</div>                    
                        </div>
                        <div className={classes.definitionLink} onClick={toggleDialog}>Policy Definitions</div>                    
                    </div>
                </NotMobile>
                <Mobile>
                    <div className={classes.linksContainer} style={{ flexDirection: "column" }}>
                        <div className={classes.definitionLink} onClick={toggleDialog}>Policy Definitions</div>                    
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div className={`${classes.definitionLink} ${classes.mobileSubmit}`} onClick={togglePolicy}>
                                <Button variant="contained" color="primary">
                                    Submit Policy
                                </Button>
                            </div>
                            <div className={`${classes.definitionLink} ${classes.mobileSubmit}`} onClick={toggleReview} style={{ marginLeft: "20px" }}>
                                <Button variant="contained" color="primary">
                                    Submit Review
                                </Button>
                            </div>                    
                        </div>
                    </div>                        
                </Mobile>
                <Mobile>
                    <MobileFeatured />
                </Mobile>
                <NotMobile>
                    <Featured />
                </NotMobile>
            </Grid>
            <DefinitionDialog 
                open={definitionsOpen} 
                onClose={handleClose} 
            />
            <PolicyDialog 
                open={policyOpen} 
                onClose={togglePolicy} 
            />
            <ReviewDialog 
                open={reviewsOpen} 
                onClose={toggleReview} 
            />
            <GiveawayDialog 
                open={giveawayOpen} 
                onClose={toggleGiveawayDialog} 
                openPolicy={togglePolicy} 
                openReviews={toggleReview}                    
            />
        </Grid>
    )
}